import { render } from "./InputList.vue?vue&type=template&id=1c3e63f8&scoped=true"
import script from "./InputList.vue?vue&type=script&lang=ts"
export * from "./InputList.vue?vue&type=script&lang=ts"

import "./InputList.vue?vue&type=style&index=0&id=1c3e63f8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1c3e63f8"

export default script